import React from 'react';
import { ProductReviewsContainer } from './ProductReviewsContainer';

export const BundleReviewsContainer = () => <ProductReviewsContainer />;